import { useOffers } from "@features/offers"

const useOffer = (offerId?: string) => {
  const { isLoading, data } = useOffers()

  return {
    isLoading,
    offer:
      data?.find(
        (o) =>
          offerId !== undefined &&
          Number.parseInt(o.CustomOfferID, 10) === Number.parseInt(offerId, 10),
      ) || null,
  }
}

export default useOffer
